/**
 * Environment Configuration
 * 
 * Centralizes all environment variable access and provides defaults
 */
export class Environment {
  public static readonly API_URL = import.meta.env.VITE_API_BASE_URL || '/api';
  
  public static readonly API_ENDPOINTS = {
    AUTH: {
      LOGIN: '/Auth/login',
      LOGOUT: '/Auth/logout',
      REFRESH: '/Auth/refresh',
    },
    CATALOG: {
      TIPOS_IDENTIFICACION: '/Catalog/tipos-identificacion',
      GENEROS: '/Catalog/generos',
      GRUPOS: '/Catalog/grupos',
      ASOCIACIONES: '/Catalog/asociaciones',
    },
  } as const;
}